var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4114 13.5C6.4114 12.6503 6.5552 11.8356 6.81216 11.0716L2.31689 7.70496C1.44077 9.44948 0.947266 11.4154 0.947266 13.5C0.947266 15.583 1.44035 17.5475 2.31502 19.291L6.80779 15.9178C6.55333 15.1573 6.4114 14.3456 6.4114 13.5Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3036 5.7701C16.1857 5.7701 17.8856 6.42417 19.2213 7.49439L23.1068 3.68893C20.7391 1.66724 17.7035 0.418579 14.3036 0.418579C9.02513 0.418579 4.4886 3.37906 2.31641 7.70492L6.81147 11.0715C7.84723 7.98801 10.7997 5.7701 14.3036 5.7701Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3036 21.2299C10.7999 21.2299 7.84744 19.012 6.81168 15.9285L2.31641 19.2945C4.4886 23.6209 9.02513 26.5814 14.3036 26.5814C17.5613 26.5814 20.6718 25.4468 23.0061 23.3211L18.7392 20.0859C17.5353 20.8297 16.0192 21.2299 14.3036 21.2299Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0532 13.4999C27.0532 12.7269 26.9317 11.8944 26.7496 11.1216H14.3037V16.1757H21.4678C21.1096 17.899 20.1346 19.2237 18.7394 20.0858L23.0062 23.321C25.4583 21.089 27.0532 17.7639 27.0532 13.4999Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d5e031e88bc0888363958a7d29513549.svg";
export { ForwardRef as ReactComponent };